module.exports = new __parcel__URL__("LiveDocIntroGALight.8a32f41a.svg").toString();